import React, { useEffect } from 'react';
import UtilService from './UtilServices';
import TimedCompanionExtension from './extensionUtil/extensionTimeSet';
import {TrackJS} from 'trackjs';

interface Props {
  pwaAppToken: string;
  iframe: HTMLIFrameElement;
}

const KioskApp = ({pwaAppToken, iframe }: Props) => {
  const query = new URLSearchParams(window.location.search);
  const pwaAppAction = query.get('pwaAppAction') ?? '';
  const isExitOp = pwaAppAction === "close_app";
  TrackJS.addMetadata("pwaAppAction", pwaAppAction);

  const onPWAInit = () => {
    if (pwaAppToken) {
      iframe.onload = () => {
        if (!iframe.getAttribute('src')) {
          console.log('Ignore onload from empty src');
          return;
        }
        const urlLandingPageWithToken = UtilService.getUrlLandingPageWithToken(pwaAppToken);
        window.open(urlLandingPageWithToken, "_self");
      }
    } else {
      return;
    }
  }

  const onExit = async (pwaAppAction: string) => {
    const chromeRuntime = chrome?.runtime;
    const operationExt = process.env.REACT_APP_KIOSK_OPS_EXTENSION_ID;
    let response;
    if (chromeRuntime) {
      try {
        response = await TimedCompanionExtension.waitForMessageOrGiveUp(chromeRuntime.sendMessage(operationExt, {
          pwaAppAction,
        }), 5000);
        console.log("Response from kiosk-ops extension", response);
        if (response?.errors) {
          console.error("Error response from kiosk-ops extension", response.errors);
          onPWAInit();
          return;
        }
      } catch (e) {
        console.error("Fail sending message to kiosk-ops extension", e);
        onPWAInit();
      }
    } else {
      onPWAInit();
    }
  }

  useEffect(() => {
    if (isExitOp) {
      onExit(pwaAppAction);
    } else {
      onPWAInit();
    }
  }, [])

  return (
    <>
    </>
  );
};

export default KioskApp;
